import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { AreaChartSomethingWrong } from './AreaChartSomethingWrong';

export type AreaChartErrorBoundaryProps = {
  children: React.ReactNode;
  xAxisLabels?: string[];
};

export const AreaChartErrorBoundary = ({ children, xAxisLabels }: AreaChartErrorBoundaryProps) => {
  return (
    <ErrorBoundary fallbackRender={() => <AreaChartSomethingWrong xAxisLabels={xAxisLabels} />}>
      {children}
    </ErrorBoundary>
  );
};
